import {FILTER_NAMES, SORT_FIELDS} from '../base.js'

const SEARCH = {
  [FILTER_NAMES.BODY_TYPE]: 'ArrBodyType',
  [FILTER_NAMES.CATEGORY_1]: 'Section1Id',
  [FILTER_NAMES.CATEGORY_2]: 'Section2Id',
  [FILTER_NAMES.COLOR]: 'ColourId',
  [FILTER_NAMES.DOOR]: {from: 'minDoors', to: 'maxDoors'},
  [FILTER_NAMES.DRIVEN_WHEELS]: 'DrivenWheelsIds',
  [FILTER_NAMES.ELECTRIC_AUTONOMY]: {from: 'minElectricAutonomy', to: 'maxElectricAutonomy'},
  [FILTER_NAMES.ELECTRIC_BATTERY_CAPACITY]: {from: 'minBatteryCapacity', to: 'maxBatteryCapacity'},
  [FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE]: {
    from: 'minChargingTimeFastMode',
    to: 'maxChargingTimeFastMode'
  },
  [FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE]: {
    from: 'minChargingTimeStandardMode',
    to: 'maxChargingTimeStandardMode'
  },
  [FILTER_NAMES.FINANCING_ENTRY]: 'entry',
  [FILTER_NAMES.FEE]: {from: 'minFee', to: 'maxFee'},
  [FILTER_NAMES.ENVIRONMENTAL_LABEL]: 'EnvironmentalLabels',
  [FILTER_NAMES.EQUIPMENTS]: 'Equipments',
  [FILTER_NAMES.EXCLUDED_VEHICLES]: {makeId: 'ExcludedMakeIds', modelId: 'ExcludedModelIds'},
  [FILTER_NAMES.FUEL_TYPE]: 'Fueltype2List',
  [FILTER_NAMES.HAS_INSTALMENT]: 'hasInstalment',
  [FILTER_NAMES.HAS_ONLINE_FINANCING]: 'hasOnlineFinancing',
  [FILTER_NAMES.HAS_PHOTO]: 'hasPhoto',
  [FILTER_NAMES.HAS_PRICE_DROP]: 'hasPriceDrop',
  [FILTER_NAMES.HAS_RESERVATION]: 'hasReservation',
  [FILTER_NAMES.HAS_STOCK]: 'hasStock',
  [FILTER_NAMES.HAS_WARRANTY]: 'wwa',
  [FILTER_NAMES.HP]: {from: 'PowerHpFrom', to: 'PowerHpTo'},
  [FILTER_NAMES.INSTALMENT]: {from: 'MinInstalmentPrice', to: 'MaxInstalmentPrice'},
  [FILTER_NAMES.IS_CERTIFIED]: 'certification',
  [FILTER_NAMES.KM]: {from: 'MinKms', to: 'MaxKms'},
  [FILTER_NAMES.LITRES]: {from: 'MinLitres', to: 'MaxLitres'},
  [FILTER_NAMES.LOCATION]: {
    lat: 'locationLat',
    long: 'locationLong',
    radio: 'locationDistance',
    text: 'locationText',
    provinceId: 'locationProvinceId'
  },
  [FILTER_NAMES.LUGGAGE_CAPACITY]: 'LuggageCapacityTypeId',
  [FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT]: 'commitmentMonths',
  [FILTER_NAMES.FINANCING_TERMS]: 'maxTerms',
  [FILTER_NAMES.OFFER_TYPE]: 'OfferType',
  [FILTER_NAMES.ONLY_PENINSULA]: 'onlyPeninsula',
  [FILTER_NAMES.PAGE_NUMBER]: 'pg',
  [FILTER_NAMES.PRICE]: {from: 'MinPrice', to: 'MaxPrice'},
  [FILTER_NAMES.PRICE_RANK]: 'priceRank',
  [FILTER_NAMES.PROVINCE]: 'arrProvince',
  [FILTER_NAMES.RATING]: {from: 'minRating', to: 'maxRating'},
  [FILTER_NAMES.SEARCH_TEXT]: 'KeyWords',
  [FILTER_NAMES.SEAT]: {from: 'MinSeats', to: 'MaxSeats'},
  [FILTER_NAMES.SELLER_TYPE]: 'st',
  [FILTER_NAMES.SORT_BY]: 'fi',
  [FILTER_NAMES.SORT_ORDER]: 'or',
  [FILTER_NAMES.TARGET_BUYER]: 'targetBuyer',
  [FILTER_NAMES.TRANSMISSION_TYPE]: 'TransmissionTypeId',
  [FILTER_NAMES.VEHICLES]: {makeId: 'MakeIds', modelId: 'ModelIds', modelName: 'Models', version: 'Versions'},
  [FILTER_NAMES.VEHICLE_STATE]: 'vehicleState',
  [FILTER_NAMES.YEAR]: {from: 'MinYear', to: 'MaxYear'}
}

const SORT = {
  [SORT_FIELDS.CC]: 'cc',
  [SORT_FIELDS.HP]: 'hp',
  [SORT_FIELDS.INSTALMENT]: 'financingInstalment',
  [SORT_FIELDS.KM]: 'Kilometers',
  [SORT_FIELDS.MONTHLY_SUBSCRIPTION_FEE]: 'monthlySubscriptionFee',
  [SORT_FIELDS.PRICE]: 'Price',
  [SORT_FIELDS.RELEVANCE]: 'SortDate',
  [SORT_FIELDS.TITLE]: 'title',
  [SORT_FIELDS.YEAR]: 'Year'
}

const USER = {
  phoneVerificationStatus: 'phoneVerificationStatus',
  returnUrl: 'returnUrl'
}

const RECOMMENDED_ADS = 'recommendedAds'
const PRICE_DROPS = 'priceDrops'

const EXPAND_TYPES = {
  [PRICE_DROPS]: 'priceDrops',
  [RECOMMENDED_ADS]: 'recommendedAds'
}

const UTM_TAGS = {
  SOURCE: 'utm_source',
  MEDIUM: 'utm_medium',
  CAMPAIGN: 'utm_campaign',
  CONTENT: 'utm_content',
  TERM: 'utm_term'
}

const ALERTS = {
  NO_MATCHES: 'noMatches'
}

export const QUERY_PARAMS = {
  ALERTS,
  EXPAND_TYPES,
  PRICE_DROPS,
  RECOMMENDED_ADS,
  SEARCH,
  SORT,
  USER,
  UTM_TAGS
}
